import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Reveal from "@/components/Reveal";
import ServiziSection from "@/sections/ServiziSection";
import { useLang } from "@/i18n";

const ServiziPage = () => {
  const { t } = useLang();
  const s = t.servizi;

  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, []);

  return (
    <main data-testid="servizi-page">
      <div className="pt-28 md:pt-40 pb-4 md:pb-10">
        <div className="max-w-5xl mx-auto px-5 md:px-10">
          <Reveal>
            <p className="eyebrow text-olive mb-7">{s.label}</p>
            <h1
              className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight"
              data-testid="servizi-page-title"
            >
              {s.pageTitle}
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 max-w-2xl text-base md:text-lg font-light leading-relaxed text-anthracite/70">
              {s.pageIntro}
            </p>
          </Reveal>
        </div>
      </div>

      <ServiziSection detailed withHeading={false} />

      <div className="max-w-5xl mx-auto px-5 md:px-10 py-16 md:py-24">
        <Reveal>
          <Link
            to="/"
            data-testid="servizi-back-home"
            className="inline-flex items-center gap-2 text-sm text-anthracite/60 hover:text-bordeaux transition-colors duration-200"
          >
            <ArrowLeft className="w-4 h-4" />
            {t.menu.backHome}
          </Link>
        </Reveal>
      </div>
    </main>
  );
};

export default ServiziPage;
